module.exports = __webpack_public_path__ + "static/media/DataClient.1b4c4145.svg";